/**
 * HUB.SMSRoute.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BillingRequestDto } from '../model/billingRequestDto';
import { DeleteResult } from '../model/deleteResult';
import { MapResponseDto } from '../model/mapResponseDto';
import { ProblemDetails } from '../model/problemDetails';
import { RouteMapModel } from '../model/routeMapModel';
import { RouteMapModelDto } from '../model/routeMapModelDto';
import { SmsRouteModel } from '../model/smsRouteModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RouteMapService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteMapDeleteDelete(id?: string, observe?: 'body', reportProgress?: boolean): Observable<DeleteResult>;
    public apiRouteMapDeleteDelete(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteResult>>;
    public apiRouteMapDeleteDelete(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteResult>>;
    public apiRouteMapDeleteDelete(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeleteResult>('delete',`${this.basePath}/api/RouteMap/delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param aggregatorId 
     * @param mnc 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteMapGet(serviceProviderId?: string, aggregatorId?: string, mnc?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SmsRouteModel>>;
    public apiRouteMapGet(serviceProviderId?: string, aggregatorId?: string, mnc?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SmsRouteModel>>>;
    public apiRouteMapGet(serviceProviderId?: string, aggregatorId?: string, mnc?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SmsRouteModel>>>;
    public apiRouteMapGet(serviceProviderId?: string, aggregatorId?: string, mnc?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (aggregatorId !== undefined && aggregatorId !== null) {
            queryParameters = queryParameters.set('aggregatorId', <any>aggregatorId);
        }
        if (mnc !== undefined && mnc !== null) {
            queryParameters = queryParameters.set('mnc', <any>mnc);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SmsRouteModel>>('get',`${this.basePath}/api/RouteMap`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param routeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteMapGetAllRouteIdGet(routeId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<MapResponseDto>>;
    public apiRouteMapGetAllRouteIdGet(routeId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MapResponseDto>>>;
    public apiRouteMapGetAllRouteIdGet(routeId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MapResponseDto>>>;
    public apiRouteMapGetAllRouteIdGet(routeId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (routeId === null || routeId === undefined) {
            throw new Error('Required parameter routeId was null or undefined when calling apiRouteMapGetAllRouteIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<MapResponseDto>>('get',`${this.basePath}/api/RouteMap/GetAll/${encodeURIComponent(String(routeId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param aggregatorId 
     * @param routeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteMapGetOneServiceProviderIdAggregatorIdRouteIdGet(serviceProviderId: string, aggregatorId: string, routeId: string, observe?: 'body', reportProgress?: boolean): Observable<RouteMapModel>;
    public apiRouteMapGetOneServiceProviderIdAggregatorIdRouteIdGet(serviceProviderId: string, aggregatorId: string, routeId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RouteMapModel>>;
    public apiRouteMapGetOneServiceProviderIdAggregatorIdRouteIdGet(serviceProviderId: string, aggregatorId: string, routeId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RouteMapModel>>;
    public apiRouteMapGetOneServiceProviderIdAggregatorIdRouteIdGet(serviceProviderId: string, aggregatorId: string, routeId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceProviderId === null || serviceProviderId === undefined) {
            throw new Error('Required parameter serviceProviderId was null or undefined when calling apiRouteMapGetOneServiceProviderIdAggregatorIdRouteIdGet.');
        }

        if (aggregatorId === null || aggregatorId === undefined) {
            throw new Error('Required parameter aggregatorId was null or undefined when calling apiRouteMapGetOneServiceProviderIdAggregatorIdRouteIdGet.');
        }

        if (routeId === null || routeId === undefined) {
            throw new Error('Required parameter routeId was null or undefined when calling apiRouteMapGetOneServiceProviderIdAggregatorIdRouteIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RouteMapModel>('get',`${this.basePath}/api/RouteMap/GetOne/${encodeURIComponent(String(serviceProviderId))}/${encodeURIComponent(String(aggregatorId))}/${encodeURIComponent(String(routeId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteMapPlatformSubscriptionResultGet(serviceProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SmsRouteModel>>;
    public apiRouteMapPlatformSubscriptionResultGet(serviceProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SmsRouteModel>>>;
    public apiRouteMapPlatformSubscriptionResultGet(serviceProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SmsRouteModel>>>;
    public apiRouteMapPlatformSubscriptionResultGet(serviceProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SmsRouteModel>>('get',`${this.basePath}/api/RouteMap/PlatformSubscriptionResult`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteMapPost(body?: RouteMapModelDto, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiRouteMapPost(body?: RouteMapModelDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiRouteMapPost(body?: RouteMapModelDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiRouteMapPost(body?: RouteMapModelDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/RouteMap`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteMapUpdateRouteMapStatusPost(body?: BillingRequestDto, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiRouteMapUpdateRouteMapStatusPost(body?: BillingRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiRouteMapUpdateRouteMapStatusPost(body?: BillingRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiRouteMapUpdateRouteMapStatusPost(body?: BillingRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/RouteMap/UpdateRouteMapStatus`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
